<template>
  <b-card no-body>
    <b-card-header>
      <b-card-title>{{ $t('confirmationsPerDay') }}</b-card-title>
      <!-- datepicker -->
      <!-- <div class="d-flex align-items-center">
        <feather-icon
          icon="CalendarIcon"
          size="16"
        />
        <flat-pickr
          v-model="rangePicker"
          :config="{ mode: 'range'}"
          class="form-control flat-picker bg-transparent border-0 shadow-none"
          placeholder="YYYY-MM-DD"
        />
      </div> -->
      <!-- datepicker -->
    </b-card-header>

    <!-- chart -->
    <b-card-body>
      <chartjs-component-bar-chart
        :height="400"
        :data="this.series"
        :options="latestBarChart.options"
      />
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardBody, BCardTitle, BCardSubTitle,
} from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import ChartjsComponentBarChart from '@/views/habit/charts-components/ChartjsComponentBarChart.vue'
import { $themeColors } from '@themeConfig'
import i18n from '@/libs/i18n'
import { EventBus } from "@/views/habit/EventBus.js";

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BCardTitle,
    BCardSubTitle,
    flatPickr,
    ChartjsComponentBarChart,
  },
  props: {
    processData: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      latestBarChart: {
        // data: {
        //   labels: ['7/12', '8/12', '9/12', '10/12', '11/12', '12/12', '13/12', '14/12', '15/12', '16/12', '17/12'],
        //   datasets: [
        //     {
        //       data: [275, 90, 190, 205, 125, 85, 55, 87, 127, 150, 230, 280, 190],
        //       backgroundColor: '#28dac6',
        //       borderColor: 'transparent',
        //     },
        //   ],
        // },
        options: {
          onHover: (event, chartElement) => {
            event.target.style.cursor = chartElement[0] ? 'pointer' : 'default';
          },
          onClick: function (c, i) {
            let e = i[0];
            if (!e) return
            var x_value = this.data.labels[e._index];
            // var y_value = this.data.datasets[0].data[e._index];
            EventBus.$emit("filterByDate", x_value);
          },
          elements: {
            rectangle: {
              borderWidth: 2,
              borderSkipped: 'bottom',
            },
          },
          responsive: true,
          maintainAspectRatio: false,
          responsiveAnimationDuration: 500,
          legend: {
            display: false,
          },
          tooltips: {
            // Updated default tooltip UI
            shadowOffsetX: 1,
            shadowOffsetY: 1,
            shadowBlur: 8,
            shadowColor: 'rgba(0, 0, 0, 0.25)',
            backgroundColor: $themeColors.light,
            titleFontColor: $themeColors.dark,
            bodyFontColor: $themeColors.dark,
          },
          scales: {
            xAxes: [
              {
                display: true,
                gridLines: {
                  display: true,
                  color: 'rgba(200, 200, 200, 0.2)',
                  zeroLineColor: 'rgba(200, 200, 200, 0.2)',
                },
                scaleLabel: {
                  display: false,
                },
                ticks: {
                  fontColor: '#6e6b7b',
                },
              },
            ],
            yAxes: [
              {
                id: "left-y-axes",
                type: "linear",
                position: "left",
                display: true,
                gridLines: {
                  color: 'rgba(200, 200, 200, 0.2)',
                  zeroLineColor: 'rgba(200, 200, 200, 0.2)',
                },
                ticks: {
                  min: 0,
                  precision: 0,
                  fontColor: '#6e6b7b',
                },
                scaleLabel: {
                  display: false,
                },
              },
            ],
          },
        },
      },
      // rangePicker: ['2019-05-01', '2019-05-10'],
    }
  },
  computed: {
    series() {
      return {
        labels: this.processData.labels,
        datasets: [
          {
            data: this.processData.data,
            label: i18n.t('label.confirmations'),
            backgroundColor: $themeColors.info,
            borderColor: 'transparent',
            barThickness: 15,
          },
        ],
      }
    },
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
